module.exports = __webpack_public_path__ + "static/img/8.ff6a0a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/8.png
// module id = 5dnn
// module chunks = 0